<template>
  <div>
    <SectionTitle :content="model.name" :has-line="true" />
    <Question
      v-for="item in model.questions"
      :key="item.id"
      :model="item"
      :readonly="readonly"
      @selected="onClickChild"
    />
  </div>
</template>
<script>
import Question from './Question';
import { SectionTitle } from '@/components/pei/shared';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: false,
    };
  },
  components: {
    Question,
    SectionTitle,
  },
  methods: {
    validate() {
      this.isValid = this.model.questions.findIndex((x) => !x.selected) === -1;
      this.$emit('changed', this.model, this.isValid);
    },
    onClickChild() {
      this.validate();
    },
  },
  mounted() {
    this.validate();
  },
};
</script>

<style scoped></style>
